/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { run } from './CrownParentId';

window.addEventListener('WebComponentsReady', async () => {
  await run(document.getElementById('viewer'));
  document.getElementById('gui').style.display = 'block';
});
